export default "__VITE_ASSET__CV_Y2Ln6__"